import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface SearchQuery {
  id: string
  query: string
  timestamp: number
}

interface SearchStore {
  // 현재 검색어
  searchQuery: string
  setSearchQuery: (query: string) => void
  
  // 최근 검색어 (최대 10개)
  recentSearches: SearchQuery[]
  addRecentSearch: (query: string) => void
  removeRecentSearch: (id: string) => void
  clearRecentSearches: () => void
  
  // 검색 상태
  isSearching: boolean
  setIsSearching: (isSearching: boolean) => void
}

export const useSearchStore = create<SearchStore>()(
  persist(
    (set) => ({
      searchQuery: '',
      setSearchQuery: (query) => set({ searchQuery: query }),
      
      recentSearches: [],
      addRecentSearch: (query) => {
        if (!query.trim()) return
        
        set((state) => {
          // 중복 제거
          const filtered = state.recentSearches.filter(s => s.query !== query)
          
          // 새 검색어 추가
          const newSearch: SearchQuery = {
            id: Date.now().toString(),
            query: query.trim(),
            timestamp: Date.now()
          }
          
          // 최대 10개 유지
          const updated = [newSearch, ...filtered].slice(0, 10)
          
          return { recentSearches: updated }
        })
      },
      
      removeRecentSearch: (id) => {
        set((state) => ({
          recentSearches: state.recentSearches.filter(s => s.id !== id)
        }))
      },
      
      clearRecentSearches: () => set({ recentSearches: [] }),
      
      isSearching: false,
      setIsSearching: (isSearching) => set({ isSearching })
    }),
    {
      name: 'search-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ recentSearches: state.recentSearches })
    }
  )
)